'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { AuthQueryOptions } from '@/api';
import { LoadingPageTemplate } from '@/components/client';
import { ROUTES } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { useCustomRouter } from '@/hooks/useCustomRouter';

//* 통합 게이트 예외 경로 — 이 경로들에선 강제 이동하지 않는다.
const ALLOWED_PATHS = ['/account-integration', '/login', '/easy-certification'];

/**
 * 로그인 회원에게 동일인 통합 대상 계정이 있으면 계정통합 화면으로 강제 이동시키는
 * 블로킹 게이트. 통합이 끝나기 전에는 다른 작업을 할 수 없다.
 */
export const AccountIntegrationController = () => {
  const $ = _c(10);
  const pathname = usePathname();
  const router = useCustomRouter();
  const {
    accessToken
  } = useAccessToken();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v3/auth/account-integration/candidates"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !!accessToken;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: hasCandidates
  } = useQuery(t2);
  let t3;
  if ($[3] !== pathname) {
    t3 = pathname ? ALLOWED_PATHS.some(path => pathname.startsWith(path)) : true;
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isAllowedPath = t3;
  const isRedirecting = hasCandidates === true && !isAllowedPath;
  let t4;
  let t5;
  if ($[5] !== isRedirecting || $[6] !== router) {
    t4 = () => {
      if (!isRedirecting) {
        return;
      }
      router.replace(ROUTES.ACCOUNT_INTEGRATION.withSearchParams({
        searchParams: {
          redirect: location.pathname + location.search
        }
      }));
    };
    t5 = [isRedirecting, router];
    $[5] = isRedirecting;
    $[6] = router;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  if (!isRedirecting) {
    return null;
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LoadingPageTemplate />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return (context?.totalCount ?? 0) > 0;
}